// Registro en memoria de los PDF adjuntos — ADR-2026-09-08-el-agente-lee-y-crea-pdfs.
//
// Mismo criterio que el lote de fotos y las planillas: los bytes de un PDF de 60 páginas no
// se persisten en `agent_chats` con cada mensaje del historial. En el mensaje queda el
// resumen; el contenido vive acá. Tras una recarga no está, y `ver_pdf` lo dice.

import type { Pdf } from './pdf';

const registro = new Map<string, Pdf>();

const nuevoId = (): string => {
  try {
    return `pdf-${crypto.randomUUID().slice(0, 8)}`;
  } catch {
    return `pdf-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`;
  }
};

export function registrarPdf(pdf: Pdf): string {
  const id = nuevoId();
  registro.set(id, pdf);
  return id;
}

export function obtenerPdf(id: string | null | undefined): Pdf | null {
  if (!id) return null;
  return registro.get(id) ?? null;
}

export function liberarPdf(id: string | null | undefined): void {
  if (id) registro.delete(id);
}

/**
 * Tira TODO el registro. Es lo que corre al cambiar de cuenta: el `Map` es de módulo y
 * sobrevive al remontaje del provider, así que sin esto los documentos de la cuenta
 * anterior seguían en la memoria de la pestaña
 * (ADR-2026-09-09-los-documentos-en-memoria-se-liberan). También lo usan los tests.
 */
export function vaciarRegistroDePdfs(): void {
  registro.clear();
}
